import {CLIENT_ID, DIRECTORY_SERVICE_URL} from './constants'
const env = process.env.REACT_APP_ENV

export const serviceEndPoint = (path) => {
  return DIRECTORY_SERVICE_URL[env] + path;
}
export const clientId = () => {
  return CLIENT_ID[env];
}

export default { serviceEndPoint, clientId };
